import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { CookieManagerService } from '../../../../../shared/services/cookie-manager.service';
import { Constants } from '../../../../../app.const';
import { WorkConstants } from "../../../../work/work.const";

declare var $: any;

@Component({
  selector: 'app-quick-access',
  templateUrl: './quick-access.component.html',
  styleUrls: ['./quick-access.component.css']
})
export class QuickAccessComponent implements OnInit {

  quickAccessList: Array<any> = [];
  mainUrl: string;
  authUser: any = {};
  link: any = {};
  private constants = Constants;

  constructor(
    private cookieManagerService: CookieManagerService,
  ) { }

  ngOnInit() {
    this.getAuthUser();
    this.checkAdminUserPermission();    
    this.mainUrl = this.constants.mainUrl;    
  }

   /**
 * kaushalya
 * 2017-07-25
 * get log user details from the cookies
 */
  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

  /**
   * kaushalya
   * 2017-07-25
   * check user is adminUser or supervisor to give view permission for div
   */

  checkAdminUserPermission() {
    if (this.authUser.user_role_id == WorkConstants.basicConstans.adminRoleId) {
      $('#quick-access').hide();
    }else{
      
      if(this.authUser.user_role_id == WorkConstants.basicConstans.supervisorRoleId){
        this.link = this.constants.quickAccessForSupervisor;
      }else{
        this.link = this.constants.quickAccessForEss;
      }
        this.quickAccessList = Object.keys(this.link).map((key) => { return this.link[key] });      
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/quick-access/quick-access.component.ts